( () => {

	/**
	 * Block name
	 *
	 * @type {string}
	 */
	const blockName = 'tabbed-content';

	/**
	 * Init
	 */
	window.addEventListener( 'load', ( ) => {

		const blocks = document.querySelectorAll( `.block-${ blockName }` );
		if ( blocks.length > 0 ) {

			blocks.forEach( ( block ) => {

				initializeBlock( block );

			} );

		}

	} );

	/**
	 * Block init
	 *
	 * @param {mixed} block
	 */
	const initializeBlock = ( block ) => {

		if ( block[ 0 ] !== undefined ) {

			block = block[ 0 ].querySelector( `.block-${ blockName }` );

		}
		if ( block === false || block === null ) {}

		const tabButtons = block.querySelectorAll( '.block-tabbed-content__navigation-button' );
		const tabContents = block.querySelectorAll( '.block-tab' );
		/**
		 * Button click event
		 */
		tabButtons.forEach( ( button ) => {

			/**
			 * Add event listener to single button
			 */
			button.addEventListener( 'click', ( event ) => {

				const tabId = event.currentTarget.getAttribute( 'data-tab' );

				tabButtons.forEach( ( btn ) => btn.classList.remove( 'active' ) );
				tabContents.forEach( ( content ) => content.classList.remove( 'active' ) );

				event.currentTarget.classList.add( 'active' );

				const activeContent = block.querySelector( `.block-tab[data-tab="${ tabId }"]` );
				if ( activeContent ) {

					activeContent.classList.add( 'active' );

				}

			} );

		} );

	};

} )();
